import { NgModule, Injector, APP_INITIALIZER} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ServiceWorkerModule } from '@angular/service-worker';

import { AppComponent } from './app.component';
import { SetAppInjector } from './app.injector';
import { AppRoutingModule } from './app-routing.module';


import { MaterialModule } from './shared/modules/material.module';
import { MasterPageModule } from './shared/modules/master-page.module';
import { ConfigService } from './shared/services/config.service';
import { CoalescingComponentFactoryResolver } from './shared/services/coalescing-component-factory-resolver.service';
import { WinAuthInterceptor, DEFAULT_TIMEOUT } from './shared/interceptors/win-auth.interceptor';
import { EmptyToolbarComponent } from './shared/components/empty-toolbar/empty-toolbar.component';
import { EmptySidenavComponent } from './shared/components/empty-sidenav/empty-sidenav.component';

import { SharedModule } from './shared/modules/shared.module';
import { IconService } from './shared/services/icon.service';
import { DialogComponent } from './shared/components/dialog/dialog.component';
import { environment } from '../environments/environment';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { AuthService } from './shared/services/auth.service';
import { MaterialIconService } from './shared/services/material-icon.service';

import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DatePipe } from '@angular/common';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

@NgModule({
    declarations: [
        AppComponent,
        EmptyToolbarComponent,
        EmptySidenavComponent,
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        MaterialModule,
        SharedModule,
        MasterPageModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    ],
    providers: [
        DatePipe,
        IconService,
        MaterialIconService,
        AuthService,
        { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
        { provide: APP_INITIALIZER, useFactory: init_app, deps: [ConfigService], multi: true, },
        { provide: HTTP_INTERCEPTORS, useClass: WinAuthInterceptor, multi: true, },
        { provide: DEFAULT_TIMEOUT, useValue: 30000 },
        //  { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
        //   useValue: { useUtc: true } },
        // { provide: DateAdapter, useClass: MomentDateAdapter,
        //   deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] } 
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
  constructor(coalescingResolver: CoalescingComponentFactoryResolver, injector: Injector, iconService: IconService,materialIconService: MaterialIconService) {
    coalescingResolver.init();
    iconService.init();
    materialIconService.init();
    SetAppInjector(injector);
  }
}

export function init_app(configService: ConfigService) {
  return () => configService.load();
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http,
    "./assets/i18n/shared/", 
    ".json",
  );
}
